import { create } from "zustand"
import { persist } from "zustand/middleware"
import createAvisoPedidoStore, { AvisoPedidoStore } from "./AvisoPedidoStore"
import createConfigsStore, { ConfigsStoreType } from "./ConfigsStore"
import createImpressaoStore, { ImpressaoStoreType } from "./ImpressaoStore.ts"
import createPedidosStore, { PedidosStoreType } from "./PedidosStore"
import createTabStatusStore, { TabStatusStoreType } from "./TabStatusStore.ts"

export type StoreType = PedidosStoreType &
    ConfigsStoreType &
    ImpressaoStoreType &
    AvisoPedidoStore &
    TabStatusStoreType

const useAppStore = create<StoreType>()(
    persist(
        (...opts) => ({
            ...createPedidosStore(...opts),
            ...createImpressaoStore(...opts),
            ...createConfigsStore(...opts),
            ...createAvisoPedidoStore(...opts),
            ...createTabStatusStore(...opts),
        }),
        {
            name: "app-store",
            partialize: state => ({
                configuracoes: state.configuracoes,
                tabStatus: state.tabStatus,
            }),
        }
    )
)

export default useAppStore
